import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { Stack, Typography } from "@mui/material";

interface Props {
  text: string;
  warningText?: string;
}

// The icon + last-modified/warning text shape meant for a SaveBar's `info` slot.
export function LastModifiedInfo({ text, warningText }: Props) {
  return (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <HistoryRoundedIcon fontSize="small" sx={{ color: "text.secondary" }} />
      <Stack>
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
        {warningText && (
          <Typography variant="body2" color="warning.dark">
            {warningText}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
